import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CheckoutWrapper } from 'components/Checkout'
import { ContractCardTemplate } from 'components/Templates'

const ContractCard: FC = () => {
  return (
    <Layout title={'クレジットカード情報編集'}>
      <CheckoutWrapper>
        <ContractCardTemplate />
      </CheckoutWrapper>
    </Layout>
  )
}

export default ContractCard
